import { z } from 'zod'

const idTokenSchema = z.object({
  name: z.string(),
  email: z.string(),
  sub: z.string(),
  given_name: z.string(),
  family_name: z.string(),
  preferred_username: z.string(),
  site: z.string(),
})

type IdTokenData = z.infer<typeof idTokenSchema>

export { idTokenSchema, type IdTokenData }
